<template>
  <div>
    <!-- {{ mvms }} -->
    <el-container class="p-3">
      <mvmSearch @onSearch="onSearch" :show_all_mvm="false" />
      <div>
        <el-form inline>
          <el-form-item>
            <el-button v-if="$route.meta.action.c" type="primary" @click="dialog = true"> 新增 </el-button>
          </el-form-item>
          <el-form-item>
            <ExportExcel v-if="clients" :export-data="clients" :columns="columns" :filename="'客戶資料'" />
          </el-form-item>
        </el-form>
      </div>
    </el-container>
    <el-table :data="mvms" style="width: 100%" :row-class-name="statusClass" height="85vh" size="medium" :fit="true">
      <el-table-column prop="AssetNo" label="機台編號" width="100" sortable />
      <el-table-column prop="locate.name" label="放置地址" width="120" />
      <el-table-column prop="model.name" label="型號" width="100" sortable />
      <el-table-column prop="client.name" label="客戶" width="120" />
      <el-table-column prop="user.name" label="巡補員" width="120">
        <template slot-scope="scope"> <i class="el-icon-user-solid" /> {{ scope.row.user.name }} </template>
      </el-table-column>
      <el-table-column prop="StockRatio" label="庫存比" width="90" sortable> </el-table-column>
      <el-table-column label="詳細資料" width="120">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            round
            plain
            @click="
              infoDialog = true;
              mvmId = scope.row.id;
            "
          >
            點擊查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="Status" label="狀態" width="100" sortable>
        <template slot-scope="scope">
          <statusTag :status="scope.row.Status" :updated-at="scope.row.updated_at" />
        </template>
      </el-table-column>

      <el-table-column prop="McDate" label="前次手動巡補" width="160" sortable>
        <template slot-scope="scope">
          <lastMcDate :updated-at="scope.row.McDate" />
        </template>
      </el-table-column>

      <el-table-column prop="IvmDate" label="前次自動巡補" width="160" sortable>
        <template slot-scope="scope">
          <lastMcDate :updated-at="scope.row.IvmDate" />
        </template>
      </el-table-column>

      <el-table-column prop="LastConnectDate" label="連線時間" width="160" sortable>
        <template slot-scope="scope">
          <lastUpdate :updated-at="scope.row.LastConnectDate" />
        </template>
      </el-table-column>
      <el-table-column label="動作">
        <template slot-scope="scope">
          <el-button v-if="$route.meta.action.u" type="text" size="small" @click="onEditClick(scope.row)"> <i class="el-icon-edit" />編輯</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog width="100%" title="機台設定" :visible.sync="dialog" @closed="mvmId = null">
      <updateForm v-if="dialog" :id="mvmId" :company-id="condition.company_id" :client-id="condition.client_id" :user-id="condition.user_id" @onSubmit="onSubmit" @onCancel="dialog = false" />
    </el-dialog>

    <el-dialog width="100%" lock-scroll :visible.sync="infoDialog" @closed="mvmId = null">
      <mvminfo v-if="infoDialog" :id="mvmId" />
    </el-dialog>
  </div>
</template>
<script>
import { getMvmSelect } from '@/api/mvms';
import dayjs from 'dayjs';
import statusTag from '@/views/mvms/components/statusTag.vue';
import lastUpdate from '@/views/mvms/components/lastUpdate.vue';
import lastMcDate from '@/views/mvms/components/lastMcDate.vue';
import mvmSearch from '@/views/mvms/components/select.vue';
import updateForm from './components/form.vue';
import mvminfo from './components/info.vue';
const disconnectTime = dayjs().subtract(10, 'minute');
const methods = {
  stockRatioToPercent(stock, max) {
    const ratio = stock / max;
    // console.log(`stock: ${stock} max: ${max} ratio: ${ratio}`);
    if (!ratio) return 'N/A';
    return `${(ratio * 100).toFixed(1)}%`;
  },
  async onSearch(condition) {
    this.condition = condition;
    this.mvms = await getMvmSelect(this.condition);
    this.mvms.forEach((mvm) => {
      // console.log(mvm);
      mvm['StockRatio'] = '0%';
      let dvm = mvm.dvm;
      if (!dvm) return;
      let stock = 0.0;
      let max = 0.0;
      try {
        dvm.gates.forEach((gate) => {
          stock += gate.Stock;
          max += gate.Max;
        });
        mvm['StockRatio'] = this.stockRatioToPercent(stock, max);
      } catch (error) {
        console.error(error);
        try {
          dvm.gates.gates.forEach((gate) => {
            stock += gate.Stock;
            max += gate.Max;
          });
          mvm['StockRatio'] = this.stockRatioToPercent(stock, max);
        } catch (error) {
          console.error(error);
        }
      }
      return mvm;
    });
  },
  async init() {},
  async onEditClick(row) {
    this.mvmId = row.id;
    this.dialog = true;
  },

  async onSubmit() {
    // console.log('onSubmit received');
    this.dialog = false;
    this.mvms = await getMvmSelect(this.condition);
    // console.log(JSON.stringify(this.mvms));
  },
  statusClass({ row, index }) {
    switch (row.Status) {
      case 3:
        return 'warning-row';
      case 2:
        return 'offline';
      default:
        return '';
    }
  },

  handleClose() {
    this.dialog = false;
  },
};

export default {
  components: {
    updateForm,
    mvmSearch,
    statusTag,
    lastUpdate,
    lastMcDate,
    mvminfo,
  },
  data() {
    return {
      mvms: [],
      clients: null,
      companyId: null,
      dialog: false,
      infoDialog: false,
      condition: {
        company_id: 1,
        client_id: null,
        user_id: null,
      },
      mvmId: null,
    };
  },
  created() {
    this.init();
  },
  methods,
};
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .offline {
  background: #fcbdbd;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
